query GetUserInboxes($threadType: ThreadType) {
    userInboxes(threadType: $threadType) {
        id
    }
}
